import React from 'react';
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import { GrFormPreviousLink, GrFormNextLink } from 'react-icons/gr';

export default function PreWorkGallery({ gallery }) {
  const thumbnails = gallery.map((item, index) => (
    <div className="myThumb" key={index}>
      <div>
        <span>{index + 1}</span>
      </div>
      <article>
        <p>{item.description}</p>
      </article>
    </div>
  ));
  const imageElements = gallery.map((item, index) => (
    <img
      src={item.image.asset.fluid.src}
      alt={item.alt}
      className="image-responsive"
      key={index}
    />
  ));
  return (
    <Carousel
      thumbnails={thumbnails}
      hasSizeButton={false}
      hasMediaButton={false}
      hasIndexBoard={false}
      hasThumbnailsAtMax
      hasTransition={false}
      thumbnailWidth="100%"
      leftIcon={<GrFormPreviousLink className="galleryNav prev" />}
      rightIcon={<GrFormNextLink className="galleryNav next" />}
    >
      {imageElements}
    </Carousel>
  );
}
